var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 152"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.002,
    y: 24.3516,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-180 24.002 24.3516)",
    fill: "#E3FFE4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow_drop_up"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_236_1069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 24.002,
    y: 24.3516,
    width: 24,
    height: 24,
    transform: "rotate(-180 24.002 24.3516)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_236_1069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "auto_graph",
    d: "M4.86726 16.7525C4.70071 16.586 4.61743 16.3938 4.61743 16.176C4.61743 15.9582 4.70071 15.766 4.86726 15.5995L9.51784 10.9489C9.59471 10.872 9.67799 10.8176 9.76767 10.7855C9.85735 10.7535 9.95343 10.7375 10.0559 10.7375C10.1584 10.7375 10.2545 10.7535 10.3442 10.7855C10.4339 10.8176 10.5171 10.872 10.594 10.9489L13.1307 13.4856L18.0503 7.951C18.1912 7.78445 18.3738 7.70117 18.598 7.70117C18.8222 7.70117 19.0112 7.77804 19.1649 7.93178C19.3059 8.07271 19.3795 8.24246 19.3859 8.44104C19.3923 8.63962 19.3251 8.81578 19.1841 8.96951L13.6688 15.1767C13.5919 15.2664 13.5054 15.3336 13.4093 15.3785C13.3133 15.4233 13.214 15.4457 13.1115 15.4457C13.009 15.4457 12.9097 15.4265 12.8136 15.3881C12.7175 15.3497 12.631 15.292 12.5542 15.2151L10.0559 12.7169L6.02029 16.7525C5.85374 16.9191 5.66157 17.0023 5.44378 17.0023C5.22598 17.0023 5.03381 16.9191 4.86726 16.7525Z",
    fill: "#00B007"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphHigh);
export default __webpack_public_path__ + "static/media/graph_high.609bc8cfc8999dd582a0536a40febfae.svg";
export { ForwardRef as ReactComponent };